import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
  // console.clear();
}

Sentry.init({
  dsn: 'https://ae546727ace64974bff18b41363b203d@o876803.ingest.sentry.io/4504933325668352',
  integrations: [Sentry.browserTracingIntegration()],
  tracePropagationTargets: [
    'supplierpaybev',
    'https://supplier.paybev.app/',
  ],
  // Keep current behavior from previous config; tune later if needed.
  tracesSampleRate: 1.0,
});

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
